import { Dispatch } from "redux";

import { SET_USERS } from "../reducers/users";
import { makeRequest } from "../util";
import { User, Invite } from "../components/users/types";
import { getCurrentUser } from "@/auth/firebase";

export const fetchUsers = () => {
  return async (dispatch: Dispatch) => {
    const listTeamPromise = makeRequest("list_team_members");
    const listInvitedPromise = makeRequest("list_invited_users");
    return Promise.all([listTeamPromise, listInvitedPromise])
      .then(([team_response, invited_response]) => {
        const invitedUsers = invited_response.data as Invite[];
        const users = team_response.data as User[];
        const currentUser = users.find(
          (user) => user.uid === getCurrentUser()?.uid,
        );

        dispatch({
          type: SET_USERS,
          users,
          currentUser,
          invitedUsers,
        });
      })
      .catch();
  };
};
